/**
 * Holds File attachments across the prompt-screen → project-create → workspace hop.
 * File objects cannot go on the URL; consume once when the workspace starts.
 */

let pending = [];

export function setPendingAttachments(attachments) {
  pending = Array.isArray(attachments) ? [...attachments] : [];
}

export function consumePendingAttachments() {
  const next = pending;
  pending = [];
  return next;
}
